<template>
  <fragment>
    <div class="class-making-box clearfix">
      <h3 class="f-18 text-nomal">신청 및 교육일정/정원</h3>
      <!-- <div class="white-box clearfix">
        <p class="f-14 m-b-5">
          <img src="images/s-check2.png" alt />
          기본설정
        </p>
        <div class="input-group full-width">
          <span class="input-group-addon">
            <input
              id="check1"
              class="checkbox3-sm"
              type="radio"
              name="eduPeriodType"
              value="교육일 지정"
              v-model="data.eduPeriodType"
            />
            <label for="check1" class="v-mid full-width">교육일 지정</label>
          </span>
          <span class="input-group-addon p-l-5">
            <input
              id="check2"
              class="checkbox3-sm"
              type="radio"
              name="eduPeriodType"
              value="수강생 신청"
              v-model="data.eduPeriodType"
            />
            <label for="check2" class="v-mid full-width">수강생 신청</label>
          </span>
          <span class="input-group-addon p-l-5">
            <input
              id="check3"
              class="checkbox3-sm"
              type="radio"
              name="eduPeriodType"
              value="일정 선택"
              v-model="data.eduPeriodType"
            />
            <label for="check3" class="v-mid full-width">일정 선택</label>
          </span>
        </div>
      </div> -->

      <!-- 교육일지정을 클릭했을때 노출 -->
      <div class="white-box clearfix">
        <p class="f-14 m-b-5">
          <img src="images/s-check2.png" alt />
          신청기간
        </p>
        <div class="level m-b-0">
          <div class="level-form">
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD HH:mm'"
                :minute-interval="10"
                v-model="data.applStartDate"
              >
                <input type="text" :value="data.applStartDate" />
              </VueCtkDateTimePicker>
            </span>
            <span class="text-center w20">~</span>
            <span class="date">
              <VueCtkDateTimePicker
                :min-date="data.applStartDate"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD HH:mm'"
                :minute-interval="10"
                v-model="data.applEndDate"
              >
                <input type="text" :value="data.applEndDate" />
              </VueCtkDateTimePicker>
            </span>
          </div>
        </div>
        <span class="input-group-addon w300 v-mid">
          <input
            id="check-x1"
            class="checkbox3-sm"
            type="checkbox"
            name="applOpt0"
            v-model="data.autoAcceptEnable"
          />
          <label for="check-x1" class="v-mid full-width m-0">신청접수시 자동승인</label>
        </span>
      </div>
      <div class="white-box clearfix">
        <p class="f-14 m-b-5">신청 안내</p>
        <div class="round">
          <!-- <div id="applGuide1"></div> -->
          <textarea class="full-width editorApplGuide1" cols="30" rows="10"></textarea>
        </div>
      </div>
      <div class="white-box clearfix">
        <p class="f-14 m-b-5">
          <img src="images/s-check2.png" alt />
          교육기간
        </p>
        <div class="level m-b-0">
          <div class="level-form w300">
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD'"
                :only-date="true"
                :minute-interval="10"
                v-model="data.lecEduDateList[0].eduStartDate"
              >
                <input type="text" :value="data.lecEduDateList[0].eduStartDate" />
              </VueCtkDateTimePicker>
            </span>
            <span class="text-center w20">~</span>
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD'"
                :only-date="true"
                :minute-interval="10"
                v-model="data.lecEduDateList[0].eduEndDate"
              >
                <input type="text" :value="data.lecEduDateList[0].eduEndDate" />
              </VueCtkDateTimePicker>
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="white-box clearfix">
        <p class="f-14 m-b-5">정원</p>
        <div class="input-group full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="check-8"
              class="checkbox3-sm"
              type="checkbox"
              name="eduFixedNum"
              :checked="data.lecEduDateList[0].eduFixedNum"
              @change="$event.target.checked===false?data.lecEduDateList[0].eduFixedNum=0:''"
            />
            <label for="check-8" class="v-mid full-width m-0">정원있음</label>
          </span>
          <span class="input-group-addon p-l-5 clearfix">
            <input
              class="form-control-sm m-b-0 round pull-left"
              type="text"
              v-model="data.lecEduDateList[0].eduFixedNum"
            />
            <span class="pull-left">(신청)건</span>
          </span>
        </div>
      </div> -->
      <div class="white-box clearfix">
        <p class="f-14 m-b-5">장소</p>
        <div class="input-group full-width">
          <span class="input-group-addon p-l-5 clearfix">
            <input
              class="form-control-sm m-b-0 round pull-left"
              type="text"
              v-model="data.eduLocation"
            />
          </span>
        </div>
      </div>
      <div class="white-box clearfix">
        <p class="f-14 m-b-5">교육 안내</p>
        <div class="round">
          <div id="eduGuide1"></div>
          <textarea class="full-width editorEduGuide1" cols="30" rows="10"></textarea>
        </div>
      </div>

      <!-- 수강생신청을 클릭했을때 노출 -->
      <div class="white-box clearfix" v-if="data.eduPeriodType=='수강생 신청'">
        <p class="f-14 m-b-5">
          <img src="images/s-check2.png" alt />
          신청기간
        </p>
        <p class="f-12 m-b-0">신청시작일</p>
        <div class="level m-b-0">
          <div class="level-form w300">
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD HH:mm'"
                :minute-interval="10"
                v-model="data.applStartDate"
              >
                <input type="text" :value="data.applStartDate" />
              </VueCtkDateTimePicker>
            </span>
          </div>
        </div>
        <p class="f-12 m-b-0">신청옵션</p>
        <div class="input-group m-b-5 full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="check-2"
              class="checkbox3-sm"
              type="checkbox"
              name="applOpt1"
              v-model="data.applOpt.find(e=>e.name=='교육일자 기준').enabled"
            />
            <label for="check-2" class="v-mid full-width m-0">교육일자 기준</label>
          </span>
          <span class="input-group-addon p-l-5 v-mid clearfix">
            <span class="pull-left m-l-5">교육시작일의</span>
            <input
              class="form-control-sm w80 m-l-5 m-b-0 round pull-left"
              type="text"
              v-model="data.applOpt.find(e=>e.name=='교육일자 기준').value"
            />
            <span class="pull-left m-l-5">일 전 까지</span>
          </span>
        </div>
        <div class="input-group full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="check-3"
              class="checkbox3-sm"
              type="checkbox"
              name="applOpt2"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').enabled"
            />
            <label for="check-3" class="v-mid full-width m-0">교육월 기준</label>
          </span>
          <span class="input-group-addon p-l-5 v-mid clearfix">
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').fromMonth"
            >
              <option value="지난달">지난달</option>
              <option value="지지난달">지지난달</option>
              <option value="3달전">3달전</option>
            </select>
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').fromDate"
            >
              <option
                v-for="(v,idx) in new Array(31)"
                :key="'date-key-1-'+idx"
                :value="idx+1"
              >{{idx+1}}일</option>
            </select>
            <span class="pull-left m-l-5">부터</span>
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').toMonth"
            >
              <option value="지난달">지난달</option>
              <option value="지지난달">지지난달</option>
              <option value="3달전">3달전</option>
            </select>
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').toDate"
            >
              <option
                v-for="(v,idx) in new Array(31)"
                :key="'date-key-2-'+idx"
                :value="idx+1"
              >{{idx+1}}일</option>
            </select>
            <span class="pull-left m-l-5">까지</span>
          </span>
        </div>
        <span class="input-group-addon w300 v-mid">
          <input
            id="check-x2"
            class="checkbox3-sm"
            type="checkbox"
            name="applOpt1"
            v-model="data.autoAcceptEnable"
          />
          <label for="check-x2" class="v-mid full-width m-0">신청접수시 자동승인</label>
        </span>
      </div>
      <div class="white-box clearfix" v-if="data.eduPeriodType=='수강생 신청'">
        <p class="f-14 m-b-5">신청 안내</p>
        <div class="round">
          <div id="applGuide2"></div>
          <!--<textarea class="full-width" name id cols="30" rows="10" v-model="data.applGuide"></textarea>-->
        </div>
      </div>
      <div class="white-box clearfix" v-if="data.eduPeriodType=='수강생 신청'">
        <p class="f-14 m-b-5">
          <img src="images/s-check2.png" alt />
          교육기간
        </p>
        <p class="f-12 m-b-0">신청가능기간</p>
        <div class="level m-b-0">
          <div class="level-form w300">
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD'"
                :only-date="true"
                :minute-interval="10"
                v-model="data.lecEduDateList[0].eduStartDate"
              >
                <input type="text" :value="data.lecEduDateList[0].eduStartDate" />
              </VueCtkDateTimePicker>
            </span>
            <span class="text-center w20">~</span>
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD'"
                :only-date="true"
                :minute-interval="10"
                v-model="data.lecEduDateList[0].eduEndDate"
              >
                <input type="text" :value="data.lecEduDateList[0].eduEndDate" />
              </VueCtkDateTimePicker>
            </span>
          </div>
        </div>
        <p class="f-12 m-b-0">교육기간</p>
        <div class="input-group full-width">
          <span class="input-group-addon clearfix">
            <input class="form-control-sm m-b-0 round pull-left" type="text" v-model="data.eduDay" />
            <span class="pull-left m-l-5">일</span>
          </span>
        </div>
        <p class="f-12 m-b-0">수업시간</p>
        <div class="input-group full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="ch-1"
              class="checkbox3-sm"
              type="radio"
              name="time"
              value="0"
              v-model="data.eduDuration"
            />
            <label for="ch-1" class="v-mid full-width m-0">상시</label>
          </span>
          <span class="input-group-addon p-l-5 w140 v-mid">
            <input
              id="ch-2"
              class="checkbox3-sm"
              type="radio"
              name="time"
              value="40"
              v-model="data.eduDuration"
            />
            <label for="ch-2" class="v-mid full-width m-0">40분</label>
          </span>
          <span class="input-group-addon p-l-5 w140 v-mid">
            <input
              id="ch-3"
              class="checkbox3-sm"
              type="radio"
              name="time"
              value="60"
              v-model="data.eduDuration"
            />
            <label for="ch-3" class="v-mid full-width m-0">60분</label>
          </span>
          <span class="input-group-addon p-l-5 w140 v-mid">
            <input
              id="ch-4"
              class="checkbox3-sm"
              type="radio"
              name="time"
              value="90"
              v-model="data.eduDuration"
            />
            <label for="ch-4" class="v-mid full-width m-0">90분</label>
          </span>
          <span class="input-group-addon p-l-5 w140 v-mid">
            <input
              id="ch-5"
              class="checkbox3-sm"
              type="radio"
              name="time"
              value="120"
              v-model="data.eduDuration"
            />
            <label for="ch-5" class="v-mid full-width m-0">120분</label>
          </span>
        </div>
      </div>
      <div class="white-box clearfix" v-if="data.eduPeriodType=='수강생 신청'">
        <p class="f-14 m-b-5">정원</p>
        <div class="input-group full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="check-4"
              class="checkbox3-sm"
              type="checkbox"
              name="eduFixedNum"
              :checked="data.lecEduDateList[0].eduFixedNum!==0"
              @change="$event.target.checked===false?data.lecEduDateList[0].eduFixedNum=0:''"
            />
            <label for="check-4" class="v-mid full-width m-0">정원있음</label>
          </span>
          <span class="input-group-addon p-l-5 clearfix">
            <input
              class="form-control-sm m-b-0 round pull-left"
              type="text"
              v-model="data.lecEduDateList[0].eduFixedNum"
            />
            <span class="pull-left">(신청)건</span>
          </span>
        </div>
      </div>
      <div class="white-box clearfix" v-if="data.eduPeriodType=='수강생 신청'">
        <p class="f-14 m-b-5">교육 안내</p>
        <div class="round">
          <div id="eduGuide2"></div>
          <!--<textarea class="full-width" name id cols="30" rows="10" v-model="data.eduGuide"></textarea>-->
        </div>
      </div>

      <!-- 일정선택을 클릭했을때 노출 -->
      <div class="white-box clearfix" v-if="data.eduPeriodType=='일정 선택'">
        <p class="f-14 m-b-5">
          <img src="images/s-check2.png" alt />
          신청기간
        </p>
        <p class="f-12 m-b-0">신청시작일</p>
        <div class="level m-b-0">
          <div class="level-form w300">
            <span class="date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :format="'YYYY-MM-DD HH:mm'"
                :minute-interval="10"
                v-model="data.applStartDate"
              >
                <input type="text" :value="data.applStartDate" />
              </VueCtkDateTimePicker>
            </span>
          </div>
        </div>
        <p class="f-12 m-b-0">신청옵션</p>
        <div class="input-group m-b-5 full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="check-2"
              class="checkbox3-sm"
              type="checkbox"
              name="applOpt1"
              v-model="data.applOpt.find(e=>e.name=='교육일자 기준').enabled"
            />
            <label for="check-2" class="v-mid full-width m-0">교육일자 기준</label>
          </span>
          <span class="input-group-addon p-l-5 v-mid clearfix">
            <span class="pull-left m-l-5">교육시작일의</span>
            <input
              class="form-control-sm w80 m-l-5 m-b-0 round pull-left"
              type="text"
              v-model="data.applOpt.find(e=>e.name=='교육일자 기준').value"
            />
            <span class="pull-left m-l-5">일 전 까지</span>
          </span>
        </div>
        <div class="input-group full-width">
          <span class="input-group-addon w140 v-mid">
            <input
              id="check-3"
              class="checkbox3-sm"
              type="checkbox"
              name="applOpt2"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').enabled"
            />
            <label for="check-3" class="v-mid full-width m-0">교육월 기준</label>
          </span>
          <span class="input-group-addon p-l-5 v-mid clearfix">
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').fromMonth"
            >
              <option value="지난달">지난달</option>
              <option value="지지난달">지지난달</option>
              <option value="3달전">3달전</option>
            </select>
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').fromDate"
            >
              <option
                v-for="(v,idx) in new Array(31)"
                :key="'date-key-3-'+idx"
                :value="idx+1"
              >{{idx+1}}일</option>
            </select>
            <span class="pull-left m-l-5">부터</span>
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').toMonth"
            >
              <option value="지난달">지난달</option>
              <option value="지지난달">지지난달</option>
              <option value="3달전">3달전</option>
            </select>
            <select
              class="form-control-sm m-l-5 m-b-0 round pull-left"
              v-model="data.applOpt.find(e=>e.name=='교육월 기준').toDate"
            >
              <option
                v-for="(v,idx) in new Array(31)"
                :key="'date-key-4-'+idx"
                :value="idx+1"
              >{{idx+1}}일</option>
            </select>
            <span class="pull-left m-l-5">까지</span>
          </span>
        </div>
        <span class="input-group-addon w300 v-mid">
          <input
            id="check-x3"
            class="checkbox3-sm"
            type="checkbox"
            name="applOpt3"
            v-model="data.autoAcceptEnable"
          />
          <label for="check-x3" class="v-mid full-width m-0">신청접수시 자동승인</label>
        </span>
      </div>
      <div class="white-box clearfix" v-if="data.eduPeriodType=='일정 선택'">
        <p class="f-14 m-b-5">신청 안내</p>
        <div class="round">
          <div id="applGuide3"></div>
          <!--<textarea class="full-width" name id cols="30" rows="10" v-model="data.applGuide"></textarea>-->
        </div>
      </div>
    </div>
    <div class="white-box m-t-5 clearfix" v-if="data.eduPeriodType=='일정 선택'">
      <p class="f-14 m-b-5">
        <img src="images/s-check2.png" alt />
        교육일정 설정
      </p>
      <p class="f-12 m-b-0">교육일수</p>
      <div class="input-group full-width m-b-10">
        <span class="input-group-addon clearfix">
          <input class="form-control-sm m-b-0 round pull-left" type="text" v-model="data.eduDay" />
          <span class="pull-left m-l-5">일</span>
        </span>
      </div>
      <p class="f-12 m-b-0">교육기간</p>
      <div class="level pull-left">
        <div class="level-form">
          <span class="date">
            <VueCtkDateTimePicker
              :no-value-to-custom-elem="true"
              :no-button-now="true"
              :no-header="true"
              :only-date="true"
              :format="'YYYY-MM-DD'"
              :minute-interval="10"
              v-model="typeData3.calendarRangeStart"
            >
              <input type="text" :value="typeData3.calendarRangeStart" />
            </VueCtkDateTimePicker>
          </span>
          <span class="text-center w20">~</span>
          <span class="date">
            <VueCtkDateTimePicker
              :min-date="typeData3.calendarRangeStart"
              :no-value-to-custom-elem="true"
              :no-button-now="true"
              :no-header="true"
              :only-date="true"
              :format="'YYYY-MM-DD'"
              :minute-interval="10"
              v-model="typeData3.calendarRangeEnd"
            >
              <input type="text" :value="typeData3.calendarRangeEnd" />
            </VueCtkDateTimePicker>
          </span>
          <span>
            <button class="btn-sm round" type="button" @click="setTypeData3NextMonth">다음달</button>
            <button class="btn-sm round" type="button" @click="setTypeData3Next3Month">3개월</button>
          </span>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="full-width" v-if="currentYearMonth && Object.keys(calendar).length">
        <div class="col-md-6">
          <div class="input-group full-width m-b-15">
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach(d=>d?d.selected=!d.selected:''))})"
              >전체 (주말포함)</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i>=1&&i<=5))?d.selected=!d.selected:''))})"
              >전체 (주말제외)</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==0))?d.selected=!d.selected:''))})"
              >일</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==1))?d.selected=!d.selected:''))})"
              >월</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==2))?d.selected=!d.selected:''))})"
              >화</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==3))?d.selected=!d.selected:''))})"
              >수</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==4))?d.selected=!d.selected:''))})"
              >목</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==5))?d.selected=!d.selected:''))})"
              >금</button>
            </span>
            <span class="input-group-addon p-l-5 v-mid">
              <button
                class="btn round"
                @click="Object.keys(calendar).forEach(k=>{calendar[k].forEach(w=>w.forEach((d,i)=>(d&&(i==6))?d.selected=!d.selected:''))})"
              >토</button>
            </span>
          </div>
          <div class="date">
            <ul class="clearfix">
              <li class="prev" style="color:#000;">
                <a @click="prevMonth" style="color:#000;">이전달</a>
              </li>
              <li class="year">{{currentYearMonth.toString().substr(0,4)}}</li>
              <li>.</li>
              <li class="mon">{{currentYearMonth.toString().substr(4,2)}}</li>
              <li class="next" style="color:#000;">
                <a @click="nextMonth" style="color:#000;">다음달</a>
              </li>
            </ul>
          </div>
          <table class="selec-table table table-bordered text-center m-b-0">
            <thead>
              <tr>
                <th>일</th>
                <th>월</th>
                <th>화</th>
                <th>수</th>
                <th>목</th>
                <th>금</th>
                <th>토</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(week,weekIndex) in calendar[currentYearMonth]"
                :key="'calendar-'+currentYearMonth+'-'+week+'-'+weekIndex+'-'+hash(week)"
              >
                <td
                  v-for="(date,dateIndex) in week"
                  :key="'calendar-'+currentYearMonth+'-'+week+'-'+weekIndex+'-date-'+dateIndex+'-'+hash(date)"
                >
                  <a
                    :class="{end:true,on:date&&data.lecEduDateList.find(e=>e.eduStartDate==currentYearMonth.toString().substr(0,4)+'-'+currentYearMonth.toString().substr(4,2)+'-'+('0'+date.date).slice(-2)),selected:date&&date.selected,active:date&&data.lecEduDateList.find(e=>e.eduStartDate==currentYearMonth.toString().substr(0,4)+'-'+currentYearMonth.toString().substr(4,2)+'-'+('0'+date.date).slice(-2))&&date.selected}"
                    @click="date?date.selected=!date.selected:''"
                  >
                    <span class="day">{{date?date.date:''}}</span>
                    <span class="deadline"></span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="form-tit m-b-0">*날짜를 클릭하면 선택/해제 할 수 있습니다.</p>
          <p class="f12 m-t-30 m-b-0">교육시간 추가</p>
          <div class="input-group full-width">
            <span class="input-group-addon date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :only-time="true"
                :format="'HH:mm'"
                :minute-interval="10"
                v-model="tempTimeRangeStart"
              >
                <input type="text" :value="tempTimeRangeStart" />
              </VueCtkDateTimePicker>
            </span>
            <span class="text-center text w20">~&nbsp;</span>
            <span class="input-group-addon date">
              <VueCtkDateTimePicker
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                :no-header="true"
                :only-time="true"
                :format="'HH:mm'"
                :minute-interval="10"
                v-model="tempTimeRangeEnd"
              >
                <input type="text" :value="tempTimeRangeEnd" />
              </VueCtkDateTimePicker>
            </span>
            <span class="input-group-addon">
              <span class="pull-left">수업시간&nbsp;</span>
              <input
                class="form-control-sm round m-b-0 w80"
                type="text"
                :value="tempTimeRangeDuration"
              />
            </span>
            <span class="input-group-addon">
              <span class="pull-left">정원&nbsp;</span>
              <input
                class="form-control-sm round m-b-0 w60"
                type="text"
                v-model="tempTimeRangeFixedNum"
              />
            </span>
            <span class="input-group-addon v-mid">
              <button
                class="btn-sm bg-deepblue text-white round"
                type="button"
                @click="appendTempTime"
              >추가</button>
            </span>
          </div>
          <p>* 신청가능한 시간의 범위를 입력하세요.</p>

          <hr v-if="tempTimeRanges.length>0" />
          <div
            class="input-group full-width m-b-10"
            v-for="(tempTime,index) in tempTimeRanges"
            :key="'temp-time-'+hash(tempTime)+'-'+hash(calendar)"
          >
            <span class="input-group-addon">{{tempTime.start}} ~ {{tempTime.end}}</span>
            <span class="input-group-addon">{{tempTime.duration}}/강의</span>
            <span class="input-group-addon">정원 {{tempTime.fixedNum}}팀</span>
            <span class="input-group-addon v-mid">
              <!--<a class="modify m-r-5">수정</a>-->
              <a class="del" @click="tempTimeRanges.splice(index,1)">삭제</a>
            </span>
          </div>
          <hr v-if="tempTimeRanges.length>0" />

          <div class="pull-right m-t-30">
            <!--<button class="btn-sm btn-red round" type="button">일정 삭제</button>-->
            &nbsp;
            <button
              class="btn-sm bg-deepblue text-white round"
              type="button"
              @click="confirmSchedule"
              v-if="tempTimeRanges.length"
            >일정 확정</button>
          </div>
        </div>
        <div class="col-md-6 class-making-time" v-if="scheduleForSelectedDays.length>0">
          <div v-for="(d,didx) in scheduleForSelectedDays" :key="'schedule-info-'+didx+'-'+hash(d)">
            <p class="f12 m-b-0">{{d.substr(0,4)}}년 {{d.substr(4,2)}}월 {{d.substr(6,2)}}일</p>
            <div
              class="input-group full-width m-b-10"
              v-for="(timeData,index) in data.lecEduDateList.filter(e=>e.eduStartDate==d.substr(0,4)+'-'+d.substr(4,2)+'-'+d.substr(6,2))"
              :key="'schedule-info-'+d+'-'+index+'-'+hash(timeData)"
            >
              <span class="input-group-addon">{{timeData.eduStartTime}} ~ {{timeData.eduEndTime}}</span>
              <span class="input-group-addon">{{timeData.eduDuration}}/강의</span>
              <span class="input-group-addon">정원 {{timeData.eduFixedNum}}팀</span>
              <span class="input-group-addon v-mid">
                <!--<a class="modify m-r-5" href="#">수정</a>-->
                <a
                  class="del"
                  @click="data.lecEduDateList.splice(data.lecEduDateList.indexOf(timeData),1)"
                >삭제</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="class-making-box clearfix">
      <div class="class-making-box" v-if="data.eduPeriodType=='일정 선택'">
        <div class="white-box clearfix">
          <p class="f-14 m-b-5">교육 안내</p>
          <div class="round">
            <div id="eduGuide3"></div>
            <!--<textarea class="full-width" cols="30" rows="10" v-model="data.eduGuide"></textarea>-->
          </div>
        </div>
      </div>

      <!-- <button
        class="btn btn-red round m-t-30 pull-left"
        type="button"
        @click="setInitValue"
      >초기값으로 설정</button> -->
      <button
        class="btn bg-deepblue text-white round m-t-30 pull-right"
        type="button"
        @click="nextStep"
      >저장하고 넘어가기</button>
      <button class="btn round m-t-30 m-r-5 pull-right" type="button" @click="skipStep">건너뛰기</button>
    </div>
  </fragment>
</template>

<script>
import fnTextEditor from '../../mixins/fnTextEditor'
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment";
// import func from '../../../vue-temp/vue-editor-bridge';

export default {
  name: "SubviewClassRegisterStep_7",
	mixins: [fnTextEditor],
  components: {
    VueCtkDateTimePicker
  },
  data: function() {
    // "일정 선택"인 경우, 일정의 첫날과 마지막날을 구하기 위해 이 배열이 필요함.
    let tempArr = this.classData.lecEduDateList ? JSON.parse(JSON.stringify(this.classData.lecEduDateList)) : [];
    return {
      data: {
        editorApplGuide1: null,
        editorApplGuide2: null,
        editorApplGuide3: null,
        editorEduGuide1: null,
        editorEduGuide2: null,
        editorEduGuide3: null,
        applStartDate:
          typeof this.classData.applStartDate == "number"
            ? moment(this.classData.applStartDate).format("YYYY-MM-DD")
            : this.classData.applStartDate, // 신청개시일
        applEndDate:
          typeof this.classData.applEndDate == "number"
            ? moment(this.classData.applEndDate).format("YYYY-MM-DD")
            : this.classData.applEndDate, // 신청마감일
        applOpt:
          typeof this.classData.applOpt == "string"
            ? JSON.parse(this.classData.applOpt)
            : JSON.parse(JSON.stringify(this.classData.applOpt)), // 신청옵션
        autoAcceptEnable: this.classData.autoAcceptEnable || null, // 자동승인여부
        applGuide: this.classData.applGuide || "", // 신청안내
        eduLocation: this.classData.eduLocation || "", // 장소
        eduGuide: this.classData.eduGuide || "", // 교육 안내
        eduPeriodType: this.classData.eduPeriodType ? this.classData.eduPeriodType : "교육일 지정", // 스케줄형식
        eduDay: this.classData.eduDay || null, // 교육기간(일수)
        lecEduDateList: this.classData.lecEduDateList[0] ? JSON.parse(
          JSON.stringify(this.classData.lecEduDateList)
        ).map(E => {
          if(E.eduStartDate){
            if (typeof E.eduStartDate == "number")
              E.eduStartDate = moment(E.eduStartDate).format("YYYY-MM-DD");
            if (typeof E.eduEndDate == "number")
              E.eduEndDate = moment(E.eduEndDate).format("YYYY-MM-DD");
          }
          return E;
        }) // 스케줄 목록
        : [{}]
      },
      typeData3: {
        calendarRangeStart: tempArr[0] ? tempArr[0].eduStartDate : "",
        calendarRangeEnd: tempArr[tempArr.length-1] ? tempArr[tempArr.length-1].eduStartDate : "" 
      },
      calendar: {},
      currentYearMonth: "",
      tempTimeRanges: [],
      tempTimeRangeStart: "",
      tempTimeRangeEnd: "",
      tempTimeRangeFixedNum: 1
    };
  },
  props: {
    classData: Object,
    default: Object
  },
  mounted: function() {
    // console.log('data.lecEduDateList[0].eduFixedNum', this.data.lecEduDateList[0].eduFixedNum)
    this.initEditor({
			selector:'.editorApplGuide1', 
			contentName:'applGuide',
			editorContentName: 'editorApplGuide1'
		});
    this.initEditor({
			selector:'.editorEduGuide1', 
			contentName:'eduGuide',
			editorContentName: 'editorEduGuide1'
    });
  },
  watch: {
  /*
    "data.eduPeriodType": function(newValue) {
      if (newValue == "교육일 지정" || newValue == "수강생 신청") {
        this.data.lecEduDateList = [
          {
            eduStartDate: null,
            eduEndDate: null,
            eduStartTime: null,
            eduEndTime: null,
            eduDuration: "",
            eduFixedNum: 0
          }
        ];
      } 
      else if (newValue == "일정 선택") this.data.lecEduDateList = [];
    },
    "typeData3.calendarRangeStart": function() {
      let start_time = 0,
        start_year_month = 0,
        start_date_year = 0,
        start_date_month = 0,
        start_date_date = 0,
        end_time = 0,
        end_year_month = 0,
        end_date_year = 0,
        end_date_month = 0,
        end_date_date = 0;
      // 달력객체를 비운다.
      this.calendar = {};
      // 시작일과 종료일이 모두 있어야 달력그리기 가능
      if (
        this.typeData3.calendarRangeStart &&
        this.typeData3.calendarRangeEnd
      ) {
        // 시작일 준비
        start_date_year = parseInt(
          this.typeData3.calendarRangeStart.split("-")[0]
        );
        start_date_month = parseInt(
          this.typeData3.calendarRangeStart.split("-")[1]
        );
        start_date_date = parseInt(
          this.typeData3.calendarRangeStart.split("-")[2]
        );
        start_year_month = parseInt(
          this.typeData3.calendarRangeStart.split("-")[0] +
            this.typeData3.calendarRangeStart.split("-")[1]
        );
        start_time = new Date(
          start_date_year,
          start_date_month - 1,
          start_date_date,
          0,
          0,
          0
        ).getTime();
        // 종료일 준비
        end_date_year = parseInt(this.typeData3.calendarRangeEnd.split("-")[0]);
        end_date_month = parseInt(
          this.typeData3.calendarRangeEnd.split("-")[1]
        );
        end_date_date = parseInt(this.typeData3.calendarRangeEnd.split("-")[2]);
        end_year_month = parseInt(
          this.typeData3.calendarRangeEnd.split("-")[0] +
            this.typeData3.calendarRangeEnd.split("-")[1]
        );
        end_time = new Date(
          end_date_year,
          end_date_month - 1,
          end_date_date,
          23,
          59,
          59
        ).getTime();
      } else return;
      // 시작일이 속한 년-월부터 종료일이 속한 년-월까지 순회하면서 한달 단위로 달력객체를 만든다.
      for (let time = start_time; time <= end_time; ) {
        // 지금 그리고 있는 달의 년-월을 만든다.
        let this_date = new Date(time);
        let this_year = this_date.getFullYear().toString();
        let this_month = ("0" + (this_date.getMonth() + 1)).slice(-2);
        let this_year_month = parseInt(this_year + this_month);
        this.$set(this.calendar, this_year_month, []);
        // 지금 그리고 있는 달의 1일의 요일과 마지막 날짜와 마지막 날짜의 요일을 구한다.
        let this_first_day = new Date(
          this_year,
          parseInt(this_month) - 1,
          1,
          0,
          0,
          0
        ).getDay();
        let this_last_date = new Date(
          this_year,
          parseInt(this_month),
          0
        ).getDate();
        //let this_last_day = (new Date(this_year, parseInt(this_month), 0)).getDay();
        // 지금 그리고 있는 달 안에서, 1주일 단위로 순회하면서
        let week = 0,
          date = 1;
        for (;;) {
          // 지금 그리고 있는 달의 지금 그리고 있는 주를 준비한다.
          this.calendar[this_year_month].push([]);
          // 지금 그리고 있는 주가 첫째주라면, 1일의 요일까지 날짜를 넘긴다.
          if (week == 0)
            for (let skip = 0; skip < this_first_day; skip += 1)
              this.calendar[this_year_month][week].push(null);
          // 지금 그리고 있는 달이 시작일이 속한 달이면, 1일부터 시작일까지 날짜를 넘긴다.
          if (this_year_month == start_year_month) {
            while (
              this.calendar[this_year_month][week].length < 7 &&
              date < start_date_date
            ) {
              this.calendar[this_year_month][week].push(null);
              date += 1;
            }
            // 시작일까지 넘기다가 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
            if (this.calendar[this_year_month][week].length == 7) {
              week += 1;
              continue;
            }
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이 아니면, 현재날짜부터 말일까지 순회하면서 날짜를 그린다.
          if (this_year_month < end_year_month) {
            while (
              this.calendar[this_year_month][week].length < 7 &&
              date <= this_last_date
            ) {
              this.calendar[this_year_month][week].push({
                date,
                yearMonth: this_year_month,
                selected: false
              });
              date += 1;
            }
            // 말일까지 날짜가 아직 안됐는데 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
            if (
              this.calendar[this_year_month][week].length == 7 &&
              date < this_last_date
            ) {
              week += 1;
              continue;
            }
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이면, 현재날짜부터 종료일까지 순회하면서 날짜를 그린다.
          if (this_year_month == end_year_month) {
            while (
              this.calendar[this_year_month][week].length < 7 &&
              date <= end_date_date
            ) {
              this.calendar[this_year_month][week].push({
                date,
                yearMonth: this_year_month,
                selected: false
              });
              date += 1;
            }
            // 종료일까지 날짜가 아직 안됐는데 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
            if (
              this.calendar[this_year_month][week].length == 7 &&
              date < end_date_date
            ) {
              week += 1;
              continue;
            }
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이 아니고 지금 그리고 있는 주에 지금 그리고 있는 달의 말일이 포함되어 있으면,
          // 말일 이후 토요일까지 남은 날짜를 넘기고 이 달을 마무리한다.
          if (
            this_year_month < end_year_month &&
            this.calendar[this_year_month][week].find(
              d => d && d.date == this_last_date
            )
          ) {
            while (this.calendar[this_year_month][week].length < 7)
              this.calendar[this_year_month][week].push(null);
            break;
          }
          // 지금 그리고 있는 달이 종료일이 속한 달이고 지금 그리고 있는 주에 종료일 포함되어 있으면,
          // 종료일 이후 토요일까지 남은 날짜를 넘기고 종료일이 속한 달의 마지막 주까지 넘긴 뒤 이 달을 마무리한다.
          if (
            this_year_month == end_year_month &&
            this.calendar[this_year_month][week].find(
              d => d && d.date == end_date_date
            )
          ) {
            while (this.calendar[this_year_month][week].length < 7)
              this.calendar[this_year_month][week].push(null);
            // 이 달에 주가 몇개여야 하는지 산출
            let weeks_of_this_month =
              (this_first_day +
                (7 - ((this_last_date + this_first_day) % 7)) +
                this_last_date) /
              7;
            if ((this_last_date + this_first_day) % 7 == 0)
              weeks_of_this_month -= 1;
            while (this.calendar[this_year_month].length < weeks_of_this_month)
              this.calendar[this_year_month].push([
                null,
                null,
                null,
                null,
                null,
                null,
                null
              ]);
            break;
          }
          // 다음주로 이행한다.
          week += 1;
        } // 주간루프
        // 다음달로 이행한다.
        time = new Date(this_date.setMonth(this_date.getMonth() + 1)).getTime();
      } // 월간루프
      // 시작월을 달력에 표시할 첫월로 표시한다.
      this.currentYearMonth = start_year_month;
    },
    "typeData3.calendarRangeEnd": {
      handler: function() {
        let start_time = 0,
          start_year_month = 0,
          start_date_year = 0,
          start_date_month = 0,
          start_date_date = 0,
          end_time = 0,
          end_year_month = 0,
          end_date_year = 0,
          end_date_month = 0,
          end_date_date = 0;
        // 달력객체를 비운다.
        this.calendar = {};
        // 시작일과 종료일이 모두 있어야 달력그리기 가능
        if (
          this.typeData3.calendarRangeStart &&
          this.typeData3.calendarRangeEnd
        ) {
          // 시작일 준비
          start_date_year = parseInt(
            this.typeData3.calendarRangeStart.split("-")[0]
          );
          start_date_month = parseInt(
            this.typeData3.calendarRangeStart.split("-")[1]
          );
          start_date_date = parseInt(
            this.typeData3.calendarRangeStart.split("-")[2]
          );
          start_year_month = parseInt(
            this.typeData3.calendarRangeStart.split("-")[0] +
              this.typeData3.calendarRangeStart.split("-")[1]
          );
          start_time = new Date(
            start_date_year,
            start_date_month - 1,
            start_date_date,
            0,
            0,
            0
          ).getTime();
          // 종료일 준비
          end_date_year = parseInt(this.typeData3.calendarRangeEnd.split("-")[0]);
          end_date_month = parseInt(
            this.typeData3.calendarRangeEnd.split("-")[1]
          );
          end_date_date = parseInt(this.typeData3.calendarRangeEnd.split("-")[2]);
          end_year_month = parseInt(
            this.typeData3.calendarRangeEnd.split("-")[0] +
              this.typeData3.calendarRangeEnd.split("-")[1]
          );
          end_time = new Date(
            end_date_year,
            end_date_month - 1,
            end_date_date,
            23,
            59,
            59
          ).getTime();
        } else return;
        // 시작일이 속한 년-월부터 종료일이 속한 년-월까지 순회하면서 한달 단위로 달력객체를 만든다.
        for (let time = start_time; time <= end_time; ) {
          // 지금 그리고 있는 달의 년-월을 만든다.
          let this_date = new Date(time);
          let this_year = this_date.getFullYear().toString();
          let this_month = ("0" + (this_date.getMonth() + 1)).slice(-2);
          let this_year_month = parseInt(this_year + this_month);
          this.$set(this.calendar, this_year_month, []);
          // 지금 그리고 있는 달의 1일의 요일과 마지막 날짜와 마지막 날짜의 요일을 구한다.
          let this_first_day = new Date(
            this_year,
            parseInt(this_month) - 1,
            1,
            0,
            0,
            0
          ).getDay();
          let this_last_date = new Date(
            this_year,
            parseInt(this_month),
            0
          ).getDate();
          //let this_last_day = (new Date(this_year, parseInt(this_month), 0)).getDay();
          // 지금 그리고 있는 달 안에서, 1주일 단위로 순회하면서
          let week = 0,
            date = 1;
          for (;;) {
            // 지금 그리고 있는 달의 지금 그리고 있는 주를 준비한다.
            this.calendar[this_year_month].push([]);
            // 지금 그리고 있는 주가 첫째주라면, 1일의 요일까지 날짜를 넘긴다.
            if (week == 0)
              for (let skip = 0; skip < this_first_day; skip += 1)
                this.calendar[this_year_month][week].push(null);
            // 지금 그리고 있는 달이 시작일이 속한 달이면, 1일부터 시작일까지 날짜를 넘긴다.
            if (this_year_month == start_year_month) {
              while (
                this.calendar[this_year_month][week].length < 7 &&
                date < start_date_date
              ) {
                this.calendar[this_year_month][week].push(null);
                date += 1;
              }
              // 시작일까지 넘기다가 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
              if (this.calendar[this_year_month][week].length == 7) {
                week += 1;
                continue;
              }
            }
            // 지금 그리고 있는 달이 종료일이 속한 달이 아니면, 현재날짜부터 말일까지 순회하면서 날짜를 그린다.
            if (this_year_month < end_year_month) {
              while (
                this.calendar[this_year_month][week].length < 7 &&
                date <= this_last_date
              ) {
                this.calendar[this_year_month][week].push({
                  date,
                  yearMonth: this_year_month,
                  selected: false
                });
                date += 1;
              }
              // 말일까지 날짜가 아직 안됐는데 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
              if (
                this.calendar[this_year_month][week].length == 7 &&
                date < this_last_date
              ) {
                week += 1;
                continue;
              }
            }
            // 지금 그리고 있는 달이 종료일이 속한 달이면, 현재날짜부터 종료일까지 순회하면서 날짜를 그린다.
            if (this_year_month == end_year_month) {
              while (
                this.calendar[this_year_month][week].length < 7 &&
                date <= end_date_date
              ) {
                this.calendar[this_year_month][week].push({
                  date,
                  yearMonth: this_year_month,
                  selected: false
                });
                date += 1;
              }
              // 종료일까지 날짜가 아직 안됐는데 주가 꽉 차서 더 이상 못넘기는 경우, 다음주로 이행해서 계속한다.
              if (
                this.calendar[this_year_month][week].length == 7 &&
                date < end_date_date
              ) {
                week += 1;
                continue;
              }
            }
            // 지금 그리고 있는 달이 종료일이 속한 달이 아니고 지금 그리고 있는 주에 지금 그리고 있는 달의 말일이 포함되어 있으면,
            // 말일 이후 토요일까지 남은 날짜를 넘기고 이 달을 마무리한다.
            if (
              this_year_month < end_year_month &&
              this.calendar[this_year_month][week].find(
                d => d.date == this_last_date
              )
            ) {
              while (this.calendar[this_year_month][week].length < 7)
                this.calendar[this_year_month][week].push(null);
              break;
            }
            // 지금 그리고 있는 달이 종료일이 속한 달이고 지금 그리고 있는 주에 종료일 포함되어 있으면,
            // 종료일 이후 토요일까지 남은 날짜를 넘기고 종료일이 속한 달의 마지막 주까지 넘긴 뒤 이 달을 마무리한다.
            if (
              this_year_month == end_year_month &&
              this.calendar[this_year_month][week].find(
                d => d.date == end_date_date
              )
            ) {
              while (this.calendar[this_year_month][week].length < 7)
                this.calendar[this_year_month][week].push(null);
              // 이 달에 주가 몇개여야 하는지 산출
              let weeks_of_this_month =
                (this_first_day +
                  (7 - ((this_last_date + this_first_day) % 7)) +
                  this_last_date) /
                7;
              if ((this_last_date + this_first_day) % 7 == 0)
                weeks_of_this_month -= 1;
              while (this.calendar[this_year_month].length < weeks_of_this_month)
                this.calendar[this_year_month].push([
                  null,
                  null,
                  null,
                  null,
                  null,
                  null,
                  null
                ]);
              break;
            }
            // 다음주로 이행한다.
            week += 1;
          } // 주간루프
          // 다음달로 이행한다.
          time = new Date(this_date.setMonth(this_date.getMonth() + 1)).getTime();
        } // 월간루프
        // 시작월을 달력에 표시할 첫월로 표시한다.
        this.currentYearMonth = start_year_month;
        // eslint-disable-next-line
        console.log(this.currentYearMonth);
      },
      immediate: true
    }
   */
  },
  methods: {
    setInitValue: function() {
      this.data.applStartDate = this.default.applStartDate; // this.classData.applStartDate, // 신청개시일
      this.data.applEndDate = this.default.applEndDate; // this.classData.applEndDate, // 신청마감일
      this.data.autoAcceptEnable = this.default.autoAcceptEnable; // this.classData.autoAcceptEnable, // 자동승인여부
      this.data.applOpt = JSON.parse(JSON.stringify(this.default.applOpt)); // JSON.parse(JSON.stringify(this.classData.applOpt)), // 신청옵션
      this.data.applGuide = this.default.applGuide; // this.classData.applGuide, // 신청안내
      this.editorApplGuide1.html.set(this.data.applGuide);
      this.editorApplGuide2.html.set(this.data.applGuide);
      this.editorApplGuide3.html.set(this.data.applGuide);
      this.data.eduGuide = this.default.eduGuide; // this.classData.eduGuide, // 교육 안내
      this.editorEduGuide1.html.set(this.data.eduGuide);
      this.editorEduGuide2.html.set(this.data.eduGuide);
      this.editorEduGuide3.html.set(this.data.eduGuide);
      this.data.eduPeriodType = this.default.eduPeriodType; // this.classData.eduPeriodType, // 스케줄형식
      this.data.eduDay = this.default.eduDay; // this.classData.eduDay, // 교육기간(일수)
      this.data.lecEduDateList = JSON.parse(
        JSON.stringify(this.default.lecEduDateTemplList)
      ); // JSON.parse(JSON.stringify(this.classData.lecEduDateList)), // 스케줄 목록
    },
    skipStep: function() {
      this.$emit("skipStep", {});
    },
    nextStep: function() {
      if (!this.data.eduPeriodType) {
        this.$emit("alert", "신청 및 교육일정 기본설정을 선택하세요.");
        return;
      }
      if (this.data.eduPeriodType == "교육일 지정") {
        if (!this.data.applStartDate || !this.data.applEndDate) {
          this.$emit("alert", "신청기간을 입력하세요.");
          return;
        }
        if (this.data.lecEduDateList[0] && (
          !this.data.lecEduDateList[0].eduStartDate ||
          !this.data.lecEduDateList[0].eduEndDate
        )) {
          this.$emit("alert", "교육기간을 입력하세요.");
          return;
        }
      }
      if (this.data.eduPeriodType == "수강생 신청") {
        if (!this.data.applStartDate) {
          this.$emit("alert", "신청시작일을 입력하세요.");
          return;
        }
        if(!this.data.applEndDate) this.data.applEndDate = "";
        if (this.data.lecEduDateList[0] && (
          !this.data.lecEduDateList[0].eduStartDate ||
          !this.data.lecEduDateList[0].eduEndDate ||
          !this.data.eduDay
        )) {
          this.$emit("alert", "교육기간을 입력하세요.");
          return;
        }
      }
      if (this.data.eduPeriodType == "일정 선택") {
        if (!this.data.applStartDate) {
          this.$emit("alert", "신청시작일을 입력하세요.");
          return;
        }
        if(!this.data.applEndDate) this.data.applEndDate = "";
        if (!this.data.eduDay) {
          this.$emit("alert", "교육일수를 입력하세요.");
          return;
        }
        if (this.data.lecEduDateList.length == 0) {
          this.$emit("alert", "교육일정을 설정하세요.");
          return;
        }
      }
      this.$emit("nextStep", this.data);
    },
  /*
    confirmSchedule: function() {
      let selectedDays = [];
      Object.keys(this.calendar).forEach(k => {
        this.calendar[k].forEach(w => {
          w.forEach(d => {
            if (d && d.selected) {
              selectedDays.push(k + ("0" + d.date).slice(-2));
              d.selected = false;
            }
          });
        });
      });
      selectedDays.forEach(d => {
        this.tempTimeRanges.forEach(t => {
          this.data.lecEduDateList.push({
            eduStartDate:
              d.substr(0, 4) + "-" + d.substr(4, 2) + "-" + d.substr(6, 2),
            eduStartTime: t.start,
            eduEndTime: t.end,
            eduFixedNum: t.fixedNum,
            eduDuration: t.duration
          });
        });
      });
      this.tempTimeRanges = [];
    },
    appendTempTime: function() {
      if (this.tempTimeRangeStart && this.tempTimeRangeEnd) {
        this.tempTimeRanges.push({
          start: this.tempTimeRangeStart,
          end: this.tempTimeRangeEnd,
          duration: this.tempTimeRangeDuration,
          fixedNum: this.tempTimeRangeFixedNum
        });
        this.tempTimeRangeStart = "";
        this.tempTimeRangeEnd = "";
        this.tempTimeRangeFixedNum = 1;
      }
    },
    prevMonth: function() {
      if (!this.currentYearMonth) return;
      let year = parseInt(this.currentYearMonth.toString().substr(0, 4));
      let month = parseInt(this.currentYearMonth.toString().substr(4, 2));
      month -= 1;
      if (month == 0) {
        year -= 1;
        month = 12;
      }
      let key = year.toString() + ("0" + month).slice(-2);
      if (this.calendar[key]) this.currentYearMonth = key;
      return;
    },
    nextMonth: function() {
      if (!this.currentYearMonth) return;
      let year = parseInt(this.currentYearMonth.toString().substr(0, 4));
      let month = parseInt(this.currentYearMonth.toString().substr(4, 2));
      month += 1;
      if (month == 13) {
        year += 1;
        month = 1;
      }
      let key = year.toString() + ("0" + month).slice(-2);
      if (this.calendar[key]) this.currentYearMonth = key;
      return;
    },
    setTypeData3NextMonth: function() {
      let d1 = new Date();
      d1.setMonth(d1.getMonth() + 1);
      this.typeData3.calendarRangeStart =
        d1.getFullYear() + "-" + ("0" + (d1.getMonth() + 1)).slice(-2) + "-01";
      let d2 = new Date(new Date(d1.getFullYear(), d1.getMonth() + 1, 0));
      this.typeData3.calendarRangeEnd =
        d2.getFullYear() +
        "-" +
        ("0" + (d2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + d2.getDate()).slice(-2);
    },
    setTypeData3Next3Month: function() {
      let d1 = new Date();
      d1.setMonth(d1.getMonth() + 1);
      this.typeData3.calendarRangeStart =
        d1.getFullYear() + "-" + ("0" + (d1.getMonth() + 1)).slice(-2) + "-01";
      let d2 = new Date(new Date(d1.getFullYear(), d1.getMonth() + 3, 0));
      this.typeData3.calendarRangeEnd =
        d2.getFullYear() +
        "-" +
        ("0" + (d2.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + d2.getDate()).slice(-2);
    }
  */
  },

  computed: {
  /*
    scheduleForSelectedDays: function() {
      let days = [];
      Object.keys(this.calendar).forEach(k => {
        this.calendar[k].forEach(w => {
          w.forEach(d => {
            if (d && d.selected) days.push(k + ("0" + d.date).slice(-2));
          });
        });
      });
      days = days.filter(d => {
        if (
          this.data.lecEduDateList.find(
            e =>
              e.eduStartDate ==
              d.substr(0, 4) + "-" + d.substr(4, 2) + "-" + d.substr(6, 2)
          )
        )
          return true;
        else return false;
      });
      return days;
    },
    tempTimeRangeDuration: function() {
      if (this.tempTimeRangeStart && this.tempTimeRangeEnd) {
        let t1 =
          parseInt(this.tempTimeRangeStart.split(":")[0]) * 60 +
          parseInt(this.tempTimeRangeStart.split(":")[1]);
        let t2 =
          parseInt(this.tempTimeRangeEnd.split(":")[0]) * 60 +
          parseInt(this.tempTimeRangeEnd.split(":")[1]);
        return t2 - t1 + "분";
      } else {
        return "?";
      }
    },
    hasPrevMonth: function() {
      if (!this.currentYearMonth) return false;
      let year = parseInt(this.currentYearMonth.toString().substr(0, 4));
      let month = parseInt(this.currentYearMonth.toString().substr(4, 2));
      month -= 1;
      if (month == 0) {
        year -= 1;
        month = 12;
      }
      let key = year.toString() + ("0" + month).slice(-2);
      if (this.calendar[key]) return true;
      else return false;
    },
    hasNextMonth: function() {
      if (!this.currentYearMonth) return false;
      let year = parseInt(this.currentYearMonth.toString().substr(0, 4));
      let month = parseInt(this.currentYearMonth.toString().substr(4, 2));
      month += 1;
      if (month == 13) {
        year += 1;
        month = 1;
      }
      let key = year.toString() + ("0" + month).slice(-2);
      if (this.calendar[key]) return true;
      else return false;
    }
  */
  },
  filters: {
    parseRegDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  }
};
</script>

<style>
</style>